import { render, staticRenderFns } from "./ProductsSelect.vue?vue&type=template&id=d8244f84&scoped=true"
import script from "./ProductsSelect.vue?vue&type=script&lang=js"
export * from "./ProductsSelect.vue?vue&type=script&lang=js"
import style0 from "./ProductsSelect.vue?vue&type=style&index=0&id=d8244f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8244f84",
  null
  
)

export default component.exports